<app-navigation-layout [hideHeader]='true' [hideMenu]="isShowProductImages">
  <span main-container>
    <div class="row">
      <div class="col-12">
        <h3>{{ 'Shopping Basket' | translate}}</h3>
        <p>{{ 'Overview of your order' | translate }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <app-basket-view *ngIf="!isShowProductImages" [order]="order"></app-basket-view>
        <app-shop-order *ngIf="isShowProductImages" [order]="order"></app-shop-order>
      </div>
    </div>
  </span>
  <span menu-container>
    <app-basket-simple-view></app-basket-simple-view>
    <section *ngIf="!isVuPayment && partner" class="pb-3 text-lg-left text-center">
      <app-current-partner-contact></app-current-partner-contact>
    </section>
  </span>
  <span navigation-container>
    <app-backward-forward (backwardClick)="onBack()" [backTitle]="'GIFT_CARD_BACK_TITLE' | translate"
      (forwardClick)="onNext()" [forwardError]=""></app-backward-forward>
  </span>
</app-navigation-layout>
